import { type MutationResultLike } from './mutationCacheBridgeTypes.ts';

export function getMutationResultError<TData>(result?: MutationResultLike<TData> | null): unknown {
	if (!result) return undefined;
	if (result.error) return result.error;
	if (result.errors?.length) return result.errors;

	return undefined;
}
